import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema } from 'tnx-shared';
import { EventService } from 'tnx-admin-service/workflowcore/event/services';
@Component({
    selector: 'event',
    templateUrl: './event.component.html',
    styleUrls: ['./event.component.scss'],
    providers: [ComponentContextService],
})
export class EventComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _eventService: EventService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._eventService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'persistenceId', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'eventData', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'eventId', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'eventKey', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'eventName', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'eventTime', dataType: 'date', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'isProcessed', dataType: 'boolean', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'code', name: '', fullName: '', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'persistenceId' }),
            new ColumnSchemaBase({ field: 'eventData' }),
            new ColumnSchemaBase({ field: 'eventId' }),
            new ColumnSchemaBase({ field: 'eventKey' }),
            new ColumnSchemaBase({ field: 'eventName' }),
            new ColumnSchemaBase({ field: 'eventTime' }),
            new ColumnSchemaBase({ field: 'isProcessed' }),
            new ColumnSchemaBase({ field: 'currentStateCode' }),
            new ColumnSchemaBase({ field: 'code' })
        ];

        super.ngOnInit();
    }
}

